import {X3Level} from './content';
import {TimeZone} from './timezone';

export const UserStatusValues = ['Registered', 'Active', 'Inactive', 'Disabled'] as const;
export type UserStatusType = typeof UserStatusValues[number];

export const UserStatusTypeLabels: { readonly [K in UserStatusType]: string } = {
  Registered: 'Registered',
  Active: 'Active',
  Inactive: 'Inactive',
  Disabled: 'Disabled'
};

export const RoleNames = [
  'Accountant',
  'Administrator',
  'ContentManager',
  'ContentModerator',
  'Student',
  'Teacher',
  'SystemAdministrator',
  'UserManager'] as const;

export type RoleName = typeof RoleNames[number];

export const RoleLabels: { readonly [K in RoleName]: string } = {
  Accountant: 'Accountant',
  Administrator: 'Administrator',
  ContentManager: 'Content Manager',
  ContentModerator: 'Content Moderator',
  Student: 'Student',
  Teacher: 'Teacher',
  UserManager: 'User Manager',
  SystemAdministrator: 'System Administrator'
};

export interface User {
  readonly Id: number;
  readonly UserHash: string;
  readonly FirstName: string;
  readonly LastName: string;
  readonly Username: string;
  readonly Email: string;
  readonly Mobile: string;
  readonly ProfilePhotoUrl: string;

  readonly TimeZoneId: number;
  readonly TimeZone: TimeZone | null;

  readonly CreationDateTime: number;
  readonly LastLoginDateTime: number | null;

  readonly FailedLoginCount: number;
  readonly LockedUntilDateTime: number | null;

  readonly Status: UserStatusType;

  readonly Roles: readonly RoleName[];

  readonly Student: Student | null;
  readonly Teacher: Teacher | null;
}

export interface CurrentUserResponse {
  readonly User: User;
  readonly ServerTime: number;
  readonly SuggestionAllowedInterval1: number;
  readonly SuggestionAllowedInterval2: number;
}

export interface Student {
  readonly Balance: number;
  readonly CompletedLessons: number;
  readonly TotalLessons: number;
  readonly Level: X3Level | null;
  readonly LevelId: number | null;
  readonly AlfaStudentId: number;
}

export interface Teacher {
  readonly Description: string;
  readonly AlfaTeacherId: number;
}

/******************************************************************************/

export type SignInModel = {
  UsernameOrEmail: string;
  Password: string;
}

export interface SignInWithTokenModel {
  SignInToken: string;
}

export type LoginSuccessResponse = 'LoginSuccess';

export type LogoutSuccessResponse = 'LogOutSuccess';

/******************************************************************************/

export interface SetPasswordModel {
  NewPassword: string;
}

export interface UpdateOwnPasswordModel {
  OldPassword: string;
  NewPassword: string;
}

export interface SetTimeZoneRequest {
  TimeZoneId: number;
}

/******************************************************************************/

export interface UserUpdateModel {
  FirstName: string;
  LastName: string;
  Username: string;
  Email: string;
  Mobile: string;
  Password: string | null;

  TimeZoneId: number;

  Roles: RoleName[];

  Student: StudentUpdateModel | null;
  Teacher: TeacherUpdateModel | null;
}

export interface StudentUpdateModel {
  Balance: number;
  LevelId: number | null;
  AlfaStudentId: number | null;
}

export interface StudentProfileUpdateModel {
  FirstName: string;
  LastName: string;
}

export interface TeacherUpdateModel {
  Description: string;
  AlfaTeacherId: number | null;
}

/******************************************************************************/

export interface UserSearchModel {
  Page: number;

  Filter: string;
  Status: UserStatusType | null;
  CreationDateTime: string;
  LastLoginDateTime: string;
  Roles: RoleName[];
}
